<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Danh sách đề thi</h3>
      </div>
      <div class="card-title">
        <button class="btn btn-success" @click="showCreateModal = true">
          Thêm đề thi
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col-3">
          <div class="form-group">
            <el-input
              placeholder="Tên đề thi, mã đề"
              v-model="filter.name"
            ></el-input>
          </div>
        </div>
        <div class="col-6 text-right">
          <button
            class="btn btn-primary font-weight-bold mr-2"
            :class="{ 'spinner spinner-white spinner-left': loading }"
            @click="fetchList"
          >
            <i class="fa fa-search"></i> Tìm kiếm
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column prop="code" label="Mã đề" width="100">
            </el-table-column>
            <el-table-column prop="name" label="Tên đề thi"> </el-table-column>
            <el-table-column prop="center_name" label="Trung tâm">
              <template slot-scope="scope">
                <span
                  class="badge badge-primary mr-1"
                  v-for="center in scope.row.centers"
                  :key="center.id"
                  >{{ center.name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="course_name" label="Khóa học">
              <template slot-scope="scope">
                <span
                  class="badge badge-primary mr-1"
                  v-for="course in scope.row.courses"
                  :key="course.id"
                  >{{ course.name }}</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="exam_type" label="Loại thi">
              <template slot-scope="scope">
                <span class="badge badge-primary">{{
                  getExamTypeLabel(scope.row.exam_type)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="apply_from"
              label="Thời gian bắt đầu áp dụng"
              width="200"
            >
              <template slot-scope="scope">
                <span>{{ formatDateTime(scope.row.apply_from) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" width="150" align="center">
              <template slot-scope="scope">
                <!-- <button class="btn btn-sm btn-icon mr-2 btn-outline-primary" title="Sửa" @click="openDetailModal(scope.row)">
                                    <i class="fas fa-eye"></i>
                                </button> -->
                <button
                  class="btn btn-sm btn-icon mr-2 btn-outline-primary btn-sm"
                  title="Sửa"
                  @click="openEditModal(scope.row)"
                >
                  <i class="fas fa-pen-nib"></i>
                </button>
                <button
                  class="btn btn-sm btn-icon mr-2 btn-outline-primary btn-sm"
                  title="Import đề thi"
                  @click="openImportModal(scope.row)"
                >
                  <i class="fas fa-file-import"></i>
                </button>
                <a
                  title="Xóa"
                  @click="deleteExam(scope.row)"
                  href="javascript:"
                  class="btn btn-sm btn-icon btn-outline-danger btn-sm"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </template>
            </el-table-column>
          </el-table>

          <div class="edu-paginate d-flex justify-content-center mt-4">
            <paginate
              v-model="currentPage"
              :page-count="Math.ceil(total / pageSize)"
              :page-range="3"
              :margin-pages="1"
              :click-handler="handlePageChange"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
            >
            </paginate>
          </div>
        </div>
      </div>
      <MarkingExamCreateModal
        :visible="showCreateModal"
        :centers="centers"
        :courses="courses"
        :examTypes="examTypes"
        :selectedCenterIds="selectedCenterIds"
        :loadingCourses="loadingCourses"
        :orderOptions="orderOptions"
        @close="showCreateModal = false"
        @created="fetchList"
        @center-change="handleCenterChange"
      />
      <MarkingExamEditModal
        :visible="showEditModal"
        :centers="centers"
        :courses="courses"
        :examTypes="examTypes"
        :exam="editingExam"
        :selectedCenterIds="selectedCenterIds"
        :loadingCourses="loadingCourses"
        :orderOptions="orderOptions"
        @close="showEditModal = false"
        @updated="fetchList"
        @center-change="handleCenterChange"
      />
      <MarkingExamDetailModal
        :visible="showDetailModal"
        :exam="selectedExam"
        :examTypes="examTypes"
        @close="showDetailModal = false"
      />
      <el-dialog 
        width="400px"
        title="Import câu hỏi" 
        center 
        destroy-on-close
        :visible="showImportModal"
         @close="showImportModal = false">
        <ImportQuestionModal
          :examId="importExamId"
          :examCode="importExamCode" 
          @imported="handleImportedQuestions"
          @close="showImportModal = false"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GET_MARKING_EXAM_LIST,
  CREATE_MARKING_EXAM,
} from "@/core/services/store/marking/marking.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getExamTypeLabel } from "@/core/enums/marking/ExamType";
import Swal from "sweetalert2";
import Paginate from "vuejs-paginate";
import MarkingExamCreateModal from "@/components/MarkingExamCreateModal.vue";
import { GET_LIST_CENTERS } from "@/core/services/store/center/centers.module";
import { GET_LIST_COURSE } from "@/core/services/store/course/course.module";
import MarkingExamEditModal from "@/components/MarkingExamEditModal.vue";
import MarkingExamDetailModal from "@/components/MarkingExamDetailModal.vue";
import ImportQuestionModal from "@/components/ImportQuestionModal.vue";
import { CENTER_EDUTALK } from "@/core/option/centerOption";
export default {
  name: "MarkingExamIndex",
  components: {
    Paginate,
    MarkingExamCreateModal,
    MarkingExamEditModal,
    MarkingExamDetailModal,
    ImportQuestionModal,
  },

  data() {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filter: {
        name: "",
      },
      loading: false,
      showCreateModal: false,
      centers: [],
      courses: [],
      examTypes: [
        { value: 0, label: "Thi chính" },
        { value: 1, label: "Thi lại lần 1" },
        { value: 4, label: "Thi lại lần 2" },
        { value: 5, label: "Thi lại lần 3" },
        { value: 6, label: "Thi lại lần 4" },
        { value: 7, label: "Thi lại lần 5" },
        { value: 8, label: "Thi lại lần 6" },
        { value: 9, label: "Thi lại lần 7" },
        { value: 10, label: "Thi lại lần 8" },
        { value: 11, label: "Thi lại lần 9" },
        { value: 12, label: "Thi lại lần 10" },
        { value: 2, label: "Thi thử lần 1" },
        { value: 3, label: "Thi thử lần 2" },
        { value: 20, label: "Thi đầu khóa" },
      ],
      selectedCenterIds: [],
      loadingCourses: false,
      showEditModal: false,
      editingExam: null,
      showDetailModal: false,
      selectedExam: null,
      showImportModal: false,
      importExamId: null,
      importExamCode: "",
      centerIds: CENTER_EDUTALK,
      orderOptions: Array.from({ length: 5 }, (_, index) => ({
        label: `Mã đề ${index + 1}`,
        value: index + 1,
      })),
    };
  },

  mounted() {
    this.setBreadcrumb();
    this.fetchList();
    this.fetchCenters();
    this.fetchCourses();
  },

  methods: {
    getExamTypeLabel,
    async fetchList() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch(GET_MARKING_EXAM_LIST, {
          page: this.currentPage,
          pageSize: this.pageSize,
          name: this.filter.name || "",
        });
        if (!response.error) {
          this.tableData = response.data || [];
          this.total = response.pagination?.total || 0;
          this.pageSize = response.pagination?.per_page || 20;
          this.currentPage = response.pagination?.current_page || 1;
        }
      } catch (error) {
        console.error("Error fetching exam list:", error);
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },

    async deleteExam(exam) {
      const messageConfirm =
        "Bạn có chắc chắn muốn xóa đề " + exam.name + " không?";
      this.$confirm(messageConfirm, "Xác nhận", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(async () => {
        this.loading = true;
        try {
          const res = await this.$store.dispatch(
            "DELETE_MARKING_EXAM",
            exam.id
          );
          if (!res.error) {
            this.$message.success("Xoá đề thi thành công");
            this.fetchList();
          } else {
            this.$message.error("Xoá đề thi thất bại");
          }
        } catch (e) {
          this.$message.error("Xoá đề thi thất bại");
        } finally {
          this.loading = false;
        }
      });
    },

    setBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Quản lý đề thi", route: "marking-exam" },
        { title: "Danh sách đề thi" },
      ]);
    },

    async fetchCenters() {
      const res = await this.$store.dispatch(GET_LIST_CENTERS, {
        ids: this.centerIds,
      });
      this.centers = res?.data || [];
    },

    async fetchCourses(centerIds) {
      if (!centerIds) {
        this.courses = [];
        return;
      }
      this.loadingCourses = true;
      const res = await this.$store.dispatch(GET_LIST_COURSE, {
        center_ids: centerIds,
      });
      this.courses = res?.data || [];
      this.loadingCourses = false;
    },

    handleCenterChange(centerIds) {
      this.selectedCenterIds = centerIds;
      this.fetchCourses(centerIds);
    },

    async handleEditExam(form) {
      try {
        const { id, ...payload } = form;
        const res = await this.$store.dispatch("UPDATE_MARKING_EXAM", {
          id,
          ...payload,
        });
        if (!res.error) {
          this.showEditModal = false;
          this.$message.success("Cập nhật đề thi thành công");
          this.fetchList();
        }
      } catch (e) {
        Swal.fire("Lỗi", "Không thể cập nhật đề thi", "error");
      }
    },

    formatDateTime(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleString("vi-VN", { hour12: false });
    },

    openDetailModal(exam) {
      this.selectedExam = exam;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
    },
    openImportModal(exam) {
      this.importExamId = exam.id;
      this.importExamCode = exam.code;
      this.showImportModal = true;
    },
    handleImportedQuestions() {
      this.fetchList();
    },
    openEditModal(exam) {
      this.editingExam = exam;
      this.selectedCenterIds = exam.centers.map((center) => center.id) || [];
      this.fetchCourses(this.selectedCenterIds);
      this.showEditModal = true;
    },
  },
};
</script>

<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 20px;
}
</style>
